import * as React from "react"

function Icon5(props: React.SVGProps<SVGSVGElement>) {
  return (
    <img src={require('../images/10_rot2-2.png')} />
  )
}

export default Icon5